import { useCallback, useState } from "react";
import { UploadCloud, Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import { toast } from "sonner";

export function FileUpload({ onUploaded }) {
  const [dragging, setDragging] = useState(false);
  const [busy, setBusy] = useState(false);

  const handleFiles = useCallback(async (fileList) => {
    const files = Array.from(fileList);
    if (!files.length) return;
    setBusy(true);
    try {
      for (const f of files) {
        const fd = new FormData();
        fd.append("file", f);
        const { data } = await api.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
        await onUploaded(data);
      }
      toast.success(files.length > 1 ? "Archivos subidos" : "Archivo subido");
    } catch (e) {
      toast.error("No he podido subir el archivo. Revisa el formato e inténtalo otra vez.");
    } finally {
      setBusy(false);
    }
  }, [onUploaded]);

  return (
    <label
      onDragOver={(e) => { e.preventDefault(); setDragging(true); }}
      onDragLeave={() => setDragging(false)}
      onDrop={(e) => { e.preventDefault(); setDragging(false); handleFiles(e.dataTransfer.files); }}
      className={`flex flex-col items-center justify-center gap-2 border border-dashed p-6 cursor-pointer rounded-sm transition-colors ${dragging ? "border-ink bg-app" : "border-line"}`}
      data-testid="file-upload"
    >
      <input type="file" multiple accept="image/*,video/*" className="hidden" onChange={(e) => handleFiles(e.target.files)} data-testid="file-input" />
      {busy ? <Loader2 size={20} className="animate-spin text-subtle" /> : <UploadCloud size={20} strokeWidth={1.5} className="text-subtle" />}
      <div className="text-sm text-subtle text-center">{busy ? "Subiendo…" : "Arrastra fotos o videos aquí, o haz clic para elegir"}</div>
    </label>
  );
}
